interface AggregateRatingSource {
  ratingValue?: number | null;
  bestRating?: number | null;
  reviewCount?: number | null;
}

// Prefers CMS values, falling back when a field is missing
export const getAggregateRating = (source?: AggregateRatingSource | null) => ({
  '@type': 'AggregateRating',
  ratingValue: String(source?.ratingValue ?? 4.7),
  bestRating: String(source?.bestRating ?? 5),
  reviewCount: String(source?.reviewCount ?? 241),
});
